import { Button, Grid, makeStyles, Typography } from '@material-ui/core'
import React from 'react'
import { useDispatch } from 'react-redux';
import { CloudUploadSharp, Save } from '@material-ui/icons';
import { useState } from 'react';
import { FinalizarCargaScienza, uploadArchivoScienzaLiquidacionesHandler } from '../../actions/liquidaciones/liquidaciones';
import { startAlerta } from '../../actions/ui/alertas';


const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    datosFc: {
        flex: 1,
        marginTop: 15,
        marginLeft: theme.spacing(5),
    },
    button: {
        marginTop: 10,
    },
}));


export const LiquidacionesCargaScienza = () => {

    const dispatch = useDispatch();
    const classes = useStyles();
    const [archivo, setArchivo] = useState("");
    const [archivo2, setArchivo2] = useState("");

    const fileFormat = ".csv";

    const handleChangeFile = (e) => {
        if (e.target.files[0].name.toLowerCase().endsWith('.csv')) {
            dispatch(
                uploadArchivoScienzaLiquidacionesHandler(
                    e.target.files[0], setArchivo
                )
            );
        }
        else {
            dispatch(startAlerta("El archivo facturas debe tener extension csv. Intente nuevamente.", "error"))
            setArchivo("")
        }
        e.target.value = null;
    };

    const handleChangeFile2 = (e) => {
        if (e.target.files[0].name.toLowerCase().endsWith('.csv')) {
            dispatch(
                uploadArchivoScienzaLiquidacionesHandler(
                    e.target.files[0], setArchivo2
                )
            );
        }
        else {
            dispatch(startAlerta("El archivo facturas red tener extension csv. Intente nuevamente.", "error"))
            setArchivo2("")
        }
        e.target.value = null;
    };

    const handleFinalizarCarga = () => {
        if (archivo === "") {
            dispatch(startAlerta("No se encuentra cargado el archivo facturas. Intente nuevamente.", "error"))
            return;
        }
        if (archivo2 === "") {
            dispatch(startAlerta("No se encuentra cargado el archivo red. Intente nuevamente.", "error"))
            return;
        }
        dispatch(FinalizarCargaScienza(archivo, archivo2, setArchivo, setArchivo2))
    }


    return (
        <>
            <Grid container spacing={1} direction="row" justify="center" alignItems="center" style={{ marginTop: 20 }}>
                <input
                    style={{ display: "none" }}
                    id="selectArchivoExcel"
                    accept={fileFormat}
                    type="file"
                    onChange={handleChangeFile}
                />

                <Grid item xs={12} sm={8} md={6}>
                    <Grid container alignItems="center" spacing={1}>
                        <Grid item>
                            <Button
                                color="primary"
                                variant="contained"
                                className={classes.button}
                                startIcon={<CloudUploadSharp />}
                                onClick={() =>
                                    document.querySelector(`#selectArchivoExcel`).click()
                                }
                            >
                                Archivo Facturas
                            </Button>
                        </Grid>
                        <Grid item>
                            <Typography variant="h6" align="center" style={{ marginTop: 10 }}>{archivo}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid container spacing={1} direction="row" justify="center" alignItems="center" style={{ marginTop: 20 }}>
                <input
                    style={{ display: "none" }}
                    id="selectArchivoExcel2"
                    accept={fileFormat}
                    type="file"
                    onChange={handleChangeFile2}
                />

                <Grid item xs={12} sm={8} md={6}>
                    <Grid container alignItems="center" spacing={1}>
                        <Grid item>
                            <Button
                                color="primary"
                                variant="contained"
                                className={classes.button}
                                startIcon={<CloudUploadSharp />}
                                onClick={() =>
                                    document.querySelector(`#selectArchivoExcel2`).click()
                                }
                            >
                                Archivo Red
                            </Button>
                        </Grid>
                        <Grid item>
                            <Typography variant="h6" align="center" style={{ marginTop: 10 }}>{archivo2}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid
                container
                spacing={1}
                direction="row"
                justify="center"
                alignItems="center"
                style={{ marginTop: 20 }}
            >
                <Grid item xs={12} sm={6} md={4}>
                    <Button
                        color="primary"
                        variant="contained"
                        className={classes.button}
                        startIcon={<Save />}
                        onClick={handleFinalizarCarga}
                    >
                        Finalizar Carga
                    </Button>
                </Grid>

            </Grid >
        </>
    )
}
